import {MODE_CREATE} from "../../../codes";
import {rxShowTransactionEditor} from "../../../slices/transactionsSlice";
import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {selectAllAccounts} from "../../../slices/accountsSlice";
import useProject from "../../../util/useProject";
import {FabButton} from "../../../common/FabButton";

export const TransactionsFab = () => {
  const dispatch = useDispatch();

  const {runWithExpiration} = useProject();

  const accounts = useSelector(selectAllAccounts);

  const showTransactionEditor = () => dispatch(rxShowTransactionEditor({mode: MODE_CREATE, transaction: {}}));

  if (accounts.filter(a => a.active).length === 0) {
    return null;
  }

  return <FabButton onClick={runWithExpiration(showTransactionEditor)}/>;
};
